
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { BackgroundColor } from '@constants';
import { ICompanyLogos, HiltonCompanyLogos } from '@common-types';
import { IMenuState } from '@share/store/slices';
import { RootState } from '@share/utils';
import { HILTON_WORLDWIDE_PROFILE } from '@share/constants';

import './style.scss';

interface IMapStateToProps {
  menuStore: IMenuState;
}

interface IProps extends IMapStateToProps {
  isBackgroundColorDark?: boolean;
  logos: ICompanyLogos[];
  max?: number;
}

function CompanyLogosComponent(props: IProps) {
  const { isBackgroundColorDark = true, logos, max, menuStore } = props;
  const { items } = menuStore;

  // Hilton-profile accounts show the Hilton-family brand logos instead of the
  // default trusted-brands set (matching the Hilton home page).
  const isHiltonProfile = items?.profile === HILTON_WORLDWIDE_PROFILE;
  const activeLogos = isHiltonProfile ? HiltonCompanyLogos : logos;

  const logosTodisplay = max ? activeLogos.slice(0, max) : activeLogos;
  
  if (!items) {
    return null;
  }
  
  return (
    <div
      className={`company-logos ${
        isBackgroundColorDark ? BackgroundColor.dark : BackgroundColor.light
      }`}
    >
      <div className="company-logos__wrapper">
        <p className="company-logos__title sencodary-font">
          <FormattedMessage id="company.you.keep" />
        </p>
        <div className="company-logos__logos-wrapper">
          {logosTodisplay.map((item, index) => (
            <div key={index} className="company-logos__img-wrapper">
              <img className="company-logos__img" src={item.image} alt={item.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
  };
};

export const CompanyLogos = connect(mapStateToProps)(CompanyLogosComponent);
